import { render, staticRenderFns } from "./AllocateSimCardsToAgency.vue?vue&type=template&id=c45d4d16&"
import script from "./AllocateSimCardsToAgency.vue?vue&type=script&lang=js&"
export * from "./AllocateSimCardsToAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports